var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import { NOOP_LOGGER } from 'bernie-logger';
import { Store } from 'bernie-plugin-mobx';
import { getRequestHeaders } from '../common/logging-utils';
var LXStore = /** @class */function (_super) {
  __extends(LXStore, _super);
  function LXStore(bexApiSource, state, bexConfigs, logger, appConfig, requestOrContext) {
    if (state === void 0) {
      state = {};
    }
    if (logger === void 0) {
      logger = NOOP_LOGGER;
    }
    var _this = this;
    var _a, _b;
    _this = _super.call(this, state, logger) || this;
    _this.bexApiSource = bexApiSource;
    _this.bexConfigs = bexConfigs;
    _this.headers = requestOrContext && getRequestHeaders(requestOrContext);
    _this.appConfig = appConfig;
    _this.logtracing = (_b = (_a = _this.headers) === null || _a === void 0 ? void 0 : _a.cookie) === null || _b === void 0 ? void 0 : _b.includes('logtracing=true');
    return _this;
  }
  LXStore.prototype.hydrate = function (data) {
    if (data) {
      delete data.bexApiSource;
      Object.assign(this, data);
    }
    if (LXStore.isStubMode()) {
      this.bexConfigs.bexApiUrl = data.appConfig.graphqlStubURL;
    } else {
      this.bexConfigs.bexApiUrl = data.appConfig.graphqlClientURL;
    }
  };
  LXStore.isStubMode = function () {
    var _a;
    return (_a = document === null || document === void 0 ? void 0 : document.cookie) === null || _a === void 0 ? void 0 : _a.includes('lxpwastubmode=true');
  };
  return LXStore;
}(Store);
export { LXStore };